import { createSelector } from 'reselect';

import { IApplicationState } from '../../types/redux';
import { EType } from '../../repositories/journal/entities/page_info/PageInfoSchema';
import { selectMainArticlesStatus } from '../mainArticles';
import { selectArticleListStatus } from '../articleList';
import { ERequestStatus } from '../../types/requestStatus';
import { selectNewsList } from '../newsList';
import { selectBlogList } from '../blogList';

/**
 * Выбирает статус для разных листингов
 */
export const selectCurrentListingStatus = createSelector(
  (state: IApplicationState) => state,
  (_: IApplicationState, type: EType) => type,
  (state, type) => {
    switch (type) {
      case EType.MainPage:
        return selectMainArticlesStatus(state);

      case EType.Articles:
      case EType.Documents:
        return selectArticleListStatus(state);

      case EType.News:
        return selectNewsList(state).status;

      case EType.Blogs:
        return selectBlogList(state).status;

      default:
        return ERequestStatus.Initial;
    }
  },
);
